export default __webpack_public_path__ + "static/media/excetute_phy.b3cdb525.png";